import { useState, useEffect } from "react";
import {
  TableContainer, Tr, Td, Th, Table, Thead, Tbody, Icon, Button, Box, Heading,
  useToast, Spacer, Tooltip, Text, Badge, VStack
} from "@chakra-ui/react";
import { MdArrowBack, MdArrowForward, MdOutlineHome } from "react-icons/md";
import { react_api } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import { useNavigate } from "react-router-dom";
import { EditIcon, InfoIcon, SearchIcon } from '@chakra-ui/icons';

function DashboardGuest() {
  const [catalogCopy, setCatalogCopy] = useState([]);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [catalog, setCatalog] = useState([]);
  const toast = useToast();

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= Math.ceil(catalog.length / itemsPerPage)) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    const fetchCatalog = async () => {
      try {
        const options = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
        const urlFetch = `${react_api}/guestDashboard/getDashboardADP`;
        const response = await fetch(urlFetch, options);

        const result = await response.json();

        if (result.status === HTTP_STATUS_CODES.OK) {
          setCatalog(result.dashboards);
          setCatalogCopy(result.dashboards)
        }
      } catch (error) {
        toast({
          title: 'Error in API call',
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }
    };
    fetchCatalog();
  }, []);

  var paginatedData = catalog.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  var totalPages = Math.ceil(catalog.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage - 9;
  const endIndex = Math.min((currentPage) * itemsPerPage, catalog.length);
  return (
    <>
      <Box
        alignItems={"center"}
        justifyContent={"space-between"}
        display={"flex"}
        color={"rgba(11,78,90,255)"}
        bgColor={"#f6f3ec"}
        width="100%"
        maxWidth="100%"
        px={4}
      >
        <Heading>Dashboards</Heading>

        {/* Previous Page Button with Tooltip */}
        <Tooltip label="Previous Page" placement="right">
          <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} bg={"#f6f3ec"}>
            <MdArrowBack />
          </Button>
        </Tooltip>

        {/* Page Info and Dashboard Text */}
        <Box>
          Page {currentPage}/{totalPages}
          <Spacer />
          Dashboard {startIndex} - {endIndex} of {catalog.length}
        </Box>

        {/* Next Page Button with Tooltip */}
        <Tooltip label="Next Page" placement="left">
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage * itemsPerPage >= catalog.length}
            bg={"#f6f3ec"}
          >
            <MdArrowForward />
          </Button>
        </Tooltip>

        {/* Home Button */}
        <Box>
          <Tooltip label="Go back to Homepage" placement="bottom" closeOnClick={true}>
            <Button
              color={"rgba(11,78,90,255)"}
              bgColor={"#f6f3ec"}
              h={"100%"}
              onClick={() => navigate("/home")}
              leftIcon={<Icon as={MdOutlineHome} />}
            >
              Home
            </Button>
          </Tooltip>
        </Box>
      </Box>

      <Box
        overflowY="auto"
        overflowX="hidden"
        direction="column"
        h="100%"
        w="100%"
        maxWidth="100%"
        boxShadow="lg"
      >
        <TableContainer px={"1%"} paddingTop={"1%"} maxWidth="100%">
          <Table variant='striped' w="100%">
            <Thead bgColor={"#0888BE"} position="sticky" top="0">
              <Tr>
                <Th align="left" w={"20%"} color={"white"}>Dashboard</Th>
                {/* <Th color={"white"} w={"20%"} whiteSpace={"normal"} wordBreak={"break-word"}>Title</Th> */}
                <Th color={"white"} w={"40%"} whiteSpace={"normal"} wordBreak={"break-word"}>Description</Th>
                <Th color={"white"} w={"30%"} whiteSpace={"normal"} wordBreak={"break-word"}>Categories</Th>
                <Th color={"white"} w={"10%"} whiteSpace={"normal"} wordBreak={"break-word"}>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {catalog && catalog.length > 0 ? (
                paginatedData.map((item, index) => (
                  <Tr key={index}>
                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.name}</Td>
                    {/* <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.title}</Td> */}
                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.description}</Td>
                    <Td>
                      <VStack spacing={2} wrap="wrap" align="start">
                        {Array.isArray(item.categories) ? (
                          item.categories.map((cat, idx) => (
                            <Tooltip key={idx} label={cat} hasArrow>
                              <Badge
                                color="black"
                                border="1px solid #0888BE"
                                bg="transparent"
                                borderRadius="md"
                                px={1}
                                py={0}
                                maxW="150px"
                                overflow="hidden"
                                textOverflow="ellipsis"
                                whiteSpace="nowrap"
                                display="inline-block"
                              >
                                {cat}
                              </Badge>
                            </Tooltip>
                          ))
                        ) : (
                          <Text>No categories available</Text>
                        )}
                      </VStack>
                    </Td>
                    {/* <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.categories}</Td> */}
                    <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                      {/* <Box ml={4} width="100%">
                        <Icon disabled={true} as={InfoIcon} boxSize={6} onClick={() => alert("Dashboard Metadata")} _hover={{ color: "blue.200" }} />
                      </Box> */}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="4" textAlign="center">No data available</Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}

export default DashboardGuest;